import { render, staticRenderFns } from "./upload-img.vue?vue&type=template&id=b4865170&scoped=true&"
import script from "./upload-img.vue?vue&type=script&lang=js&"
export * from "./upload-img.vue?vue&type=script&lang=js&"
import style0 from "./upload-img.vue?vue&type=style&index=0&id=b4865170&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4865170",
  null
  
)

export default component.exports